import { render, staticRenderFns } from "./Make.vue?vue&type=template&id=2d4b852b&scoped=true&"
import script from "./Make.vue?vue&type=script&lang=ts&"
export * from "./Make.vue?vue&type=script&lang=ts&"
import style0 from "./Make.vue?vue&type=style&index=0&id=2d4b852b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d4b852b",
  null
  
)

export default component.exports